/**
 * D6PVGTConditionType - Condition qui vérifie si les PV sont supérieurs à une valeur
 * Identique à Java PVGTCondition
 */

import {ConditionType} from '../../types/ConditionType';
import {GameState} from '../../../models/GameState';
import GameStateHelper from '../../../helpers/GameStateHelper';

export class D6PVGTConditionType implements ConditionType {
  typeName = 'D6_COND_PV_GT';
  messageKey = 'laventurier.condition.d6.pv-gt.name';
  descriptionKey = 'laventurier.condition.d6.pv-gt.desc';
  errorKey = 'laventurier.condition.d6.pv-gt.error';
  hasValue = true;
  hasAttribute = false;

  evaluate(gameState: GameState, condition: any): boolean {
    const threshold = parseInt(condition.value || condition.threshold || '0', 10);
    if (isNaN(threshold)) {
      console.log('[D6PVGTConditionType] FALSE: invalid threshold value');
      return false;
    }

    const pvField = GameStateHelper.getAdventureExtraField(gameState, 'D6_PV');
    if (!pvField) {
      console.log('[D6PVGTConditionType] FALSE: D6_PV field not found');
      return false;
    }

    const currentPV = parseInt(String(pvField.currentValue || pvField.initValue || '0'), 10);
    const result = currentPV > threshold;
    console.log(`[D6PVGTConditionType] ${result ? 'TRUE' : 'FALSE'}: currentPV=${currentPV}, threshold=${threshold}`);
    return result;
  }
}
